import { Button, Flex, FormControl, Text } from '@chakra-ui/react';
import { useFormikContext } from 'formik';
import Select from 'react-select';
import { Search } from 'react-feather';
import { languageOptions } from 'utils';

const Languages = ({
  next,
  prev,
}: {
  next: () => void;
  prev: () => void;
}): JSX.Element => {
  const {
    values: { languages },
    setFieldValue,
    handleBlur,
  } = useFormikContext<ApplicationQuestionsValues>();

  const customStyles = {
    control: (styles: any) => ({
      ...styles,
      borderRadius: '10px',
      border: '1px solid #999999',
      backgroundColor: '#FAF8EC',
    }),
    multiValue: (styles: any) => ({
      ...styles,
      backgroundColor: '#FEF19F',
      borderRadius: '4px',
    }),
  };

  return (
    <Flex direction="column" width="100%">
      <Flex direction="column" bg="custom.levoAlabaster" py="61.5px" px={6}>
        <Text textStyle="heading3" fontWeight="bold">
          What languages can you speak?
        </Text>
        <FormControl
          id="languages"
          display="flex"
          flexDirection="column"
          mt={6}
        >
          <Select
            value={languages.map((language) => ({
              label: language,
              value: language,
            }))}
            options={languageOptions}
            isMulti
            isSearchable
            styles={customStyles}
            onChange={(value) =>
              setFieldValue(
                'languages',
                value.map(({ value }) => value),
              )
            }
            components={{
              DropdownIndicator: () => null,
              IndicatorSeparator: () => null,
            }}
            placeholder={
              <Flex alignItems="center">
                <Search size={16} />
                <Text ml={2}>Search languages</Text>
              </Flex>
            }
            onBlur={handleBlur}
          />
        </FormControl>
      </Flex>
      <Flex width="100%" justifyContent="space-between" mt={6}>
        <Button
          width="fit-content"
          height="fit-content"
          bg="custom.levoDarkSnow"
          borderRadius="8px"
          mt={6}
          py={4}
          px={6}
          onClick={prev}
        >
          <Text textStyle="body" fontWeight={700} color="custom.levoBlue">
            Back
          </Text>
        </Button>
        <Button
          width="fit-content"
          height="fit-content"
          bg="custom.levoBlue"
          borderRadius="8px"
          mt={6}
          py={4}
          px={6}
          isDisabled={!languages.length}
          onClick={next}
        >
          <Text textStyle="body" fontWeight={700} color="white">
            Next
          </Text>
        </Button>
      </Flex>
    </Flex>
  );
};

export default Languages;
